const Home = () => (
  <div className="text-white pt-5">
    <h1 className="display-1 mb-3">Welcome to our page!</h1>
    <p className="lead">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil dolore fuga odit officia
      dolores, magnam voluptates provident nam quis, doloremque ratione culpa optio maiores libero
      suscipit numquam est minima quos obcaecati recusandae labore itaque porro. Minima expedita
      facere adipisci possimus dolore quia voluptas! Reprehenderit repudiandae totam placeat, at
      vitae impedit laudantium obcaecati eaque iste, modi recusandae deleniti nulla cum repellendus
      dignissimos illum cupiditate in! Ullam illo vero perspiciatis veniam illum! Est, ex odio
      voluptatibus architecto enim voluptate velit quas dicta sit facere! Maiores beatae, ea vel
      odit possimus deleniti molestias cum. Itaque alias voluptates aperiam molestiae labore
      recusandae nihil iure?
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil dolore fuga odit officia
      dolores, magnam voluptates provident nam quis, doloremque ratione culpa optio maiores libero
      suscipit numquam est minima quos obcaecati recusandae labore itaque porro. Minima expedita
      facere adipisci possimus dolore quia voluptas! Reprehenderit repudiandae totam placeat, at
      vitae impedit laudantium obcaecati eaque iste, modi recusandae deleniti nulla cum repellendus
      dignissimos illum cupiditate in! Ullam illo vero perspiciatis veniam illum! Est, ex odio
      voluptatibus architecto enim voluptate velit quas dicta sit facere! Maiores beatae, ea vel
      odit possimus deleniti molestias cum. Itaque alias voluptates aperiam molestiae labore
      recusandae nihil iure?
    </p>
  </div>
);

export default Home;
